import React, { useState } from "react";
import styles from "./Table.module.css";
import whatsappIcon from "../../assets/image 63.png";
import { useNavigate } from "react-router";

function Table(props) {
  const [selectedRow, setSelectedRow] = useState(null);

  const navigate = useNavigate();

  const handleRowClick = (index) => {
    if (selectedRow === index) {
      setSelectedRow(null);
    } else {
      setSelectedRow(index);
    }
  };

  return (
    <div>
      <div className={styles.table_header}>
        <div className={styles.table_column}>
          <p>S/N</p>
        </div>
        <div className={styles.table_column}>
          <p>
            {props.table_type === "customers"
              ? "Plate No."
              : props.sell
                ? "Seller"
                : "Buyer"}
          </p>
        </div>
        <div className={styles.table_column}>
          <p>{props.table_type === "customers" ? "Make" : "Amount"}</p>
        </div>
        {props.table_type !== "order" ? (
          <div className={styles.table_column}>
            <p>{props.table_type === "customers" ? "Model" : "Type."}</p>
          </div>
        ) : (
          <div className={styles.table_column}>
            <p> Plate No</p>
          </div>
        )}
        <div className={styles.table_column}>
          <svg
            width="4"
            height="17"
            viewBox="0 0 4 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M2.64783 2.47626C2.64783 2.83207 2.3594 3.12049 2.00361 3.12049C1.64781 3.12049 1.35938 2.83206 1.35938 2.47626C1.35938 2.12046 1.64781 1.83203 2.00361 1.83203C2.3594 1.83203 2.64783 2.12046 2.64783 2.47626ZM2.64789 14.5203C2.64789 14.8761 2.35946 15.1645 2.00366 15.1645C1.64786 15.1645 1.35943 14.8761 1.35943 14.5203C1.35943 14.1645 1.64786 13.876 2.00366 13.876C2.35947 13.876 2.64789 14.1645 2.64789 14.5203ZM2.64783 8.52025C2.64783 8.87605 2.3594 9.16448 2.00361 9.16448C1.64781 9.16448 1.35938 8.87605 1.35938 8.52025C1.35938 8.16445 1.64781 7.87602 2.00361 7.87602C2.3594 7.87602 2.64783 8.16445 2.64783 8.52025Z"
              stroke="#36363E"
              stroke-width="2"
              stroke-linecap="round"
            />
          </svg>
        </div>
      </div>

      <div className={styles.table_inner}>
        {(props?.tableData?.data || props?.tableData)?.map((data, index) => (
          <div className={styles.table_header_wrapper}>
            <div
              key={index}
              className={styles.table_header}
              onClick={() =>
                data.order_details
                  ? navigate(`/history/${data.unique_id}`)
                  : handleRowClick(index)
              }
            >
              <div className={styles.table_column}>
                <p>{index + 1}</p>
              </div>
              <div className={styles.table_column}>
                <p>
                  {" "}
                  {props?.table_type === "customers"
                    ? data?.plate_no
                    : props.sell
                      ? data?.distributor?.fullname
                      : data?.plate_details?.fullname}
                </p>
              </div>
              <div className={styles.table_column}>
                <p>
                  {props?.table_type === "customers"
                    ? data?.make
                    : Number(data?.amount)?.toLocaleString()}
                </p>
              </div>
              <div className={styles.table_column}>
                {props?.table_type !== "order" ? (
                  <p>
                    {props?.table_type === "customers"
                      ? data?.model
                      : data?.payment_type || data?.created_at?.slice(0, 10)}
                  </p>
                ) : (
                  <p>{data?.plate_no}</p>
                )}
              </div>
              <div className={styles.table_column}>
                {props.table_type === "customers" ? (
                  <img
                    src={whatsappIcon}
                    onClick={() => {
                      props.setSendExpiryModalData(data);
                      props.setSendExpiryModal(true);
                    }}
                    alt="whatsapp"
                    style={{
                      width: "30px",
                      height: "30px",
                      objectFit: "cover",
                    }}
                  />
                ) : (
                  <div className={styles.col_actions}>
                    <div
                      style={{
                        width: "10px",
                        height: "10px",
                        borderRadius: "50%",
                        flexShrink: 0,
                        backgroundColor:
                          data?.order_status === "PENDING"
                            ? "#FFA500"
                            : data?.order_status
                              ? "#008000"
                              : "#808080",
                      }}
                    />
                    {props.table_type === "order" && props.onEditClick && (
                      <button
                        className={styles.edit_button}
                        title="Edit Policy"
                        onClick={(e) => {
                          e.stopPropagation();
                          props.onEditClick(data);
                        }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="14"
                          height="14"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
                          <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
                        </svg>
                      </button>
                    )}
                  </div>
                )}
              </div>
            </div>
            {selectedRow === index && (
              <div className={styles.row_details}>
                <div className={styles.row_details_time}>
                  <h1>
                    {
                      // props?.table_type === "customers"
                      //   ? data?.fullname
                      //   :
                      data?.created_at?.slice(0, 10)
                    }
                    {props.table_type === "customers" && (
                      <div
                        style={{
                          background: "white",
                          color: "black",
                          padding: "10px",
                        }}
                      >
                        {/* <p
                          onClick={() => {
                            props.openModalHandler();
                            props.sendLinkToModal(data?.plate_no);
                          }}
                        > */}
                        <a
                          href={`https://payvis.ng/summary?sv=${data?.plate_no}`}
                          target="_blank"
                          rel="noreferrer"
                        >
                          Check Fines
                        </a>
                        {/* </p> */}
                      </div>
                    )}
                  </h1>
                  <p>
                    {props?.table_type === "customers"
                      ? ""
                      : data?.created_at?.slice(11)}
                  </p>
                </div>
                <div
                  className={
                    data?.payment_status?.toLowerCase() !== "success"
                      ? styles.row_details_status_error
                      : styles.row_details_status
                  }
                >
                  <p>{data?.payment_status || ""}</p>
                  <div className={styles.payment_donaload}>
                    <div>
                      <div
                      // onClick={() =>
                      //   props.downloadPolicyHandler(order?.file_link)
                      // }
                      >
                        {/* <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g clip-path="url(#clip0_1_1977)">
                              <path
                                d="M13 10H18L12 16L6 10H11V3H13V10ZM4 19H20V12H22V20C22 20.2652 21.8946 20.5196 21.7071 20.7071C21.5196 20.8946 21.2652 21 21 21H3C2.73478 21 2.48043 20.8946 2.29289 20.7071C2.10536 20.5196 2 20.2652 2 20V12H4V19Z"
                                fill="#3E414C"
                              />
                            </g>
                            <defs>
                              <clipPath id="clip0_1_1977">
                                <rect width="24" height="24" fill="white" />
                              </clipPath>
                            </defs>
                          </svg> */}
                      </div>
                    </div>
                  </div>

                  {!data?.prev_balance && !data?.order_details && (
                    <div className={styles.expiryDate}>
                      <div className={styles.expiryDatePapers}>
                        <p>Papers</p>
                        <p>Road </p>
                        <p>V.License</p>
                        <p>Insurance</p>
                      </div>
                      <div className={styles.expiryDatePapers}>
                        <p>Dates</p>
                        <p
                          style={{
                            color:
                              new Date(
                                data?.road_expiry_date ||
                                  data?.plate_details?.road_expiry_date,
                              ) < new Date()
                                ? "red"
                                : "black",
                          }}
                        >
                          {data?.road_expiry_date ||
                            data?.plate_details?.road_expiry_date ||
                            "."}
                        </p>
                        <p
                          style={{
                            color:
                              new Date(
                                data?.vl_expiry_date ||
                                  data?.plate_details?.vl_expiry_date,
                              ) < new Date()
                                ? "red"
                                : "black",
                          }}
                        >
                          {data?.vl_expiry_date ||
                            data?.plate_details?.vl_expiry_date ||
                            "."}
                        </p>
                        <p
                          style={{
                            color:
                              new Date(
                                data?.expiry_date ||
                                  data?.plate_details?.expiry_date,
                              ) < new Date()
                                ? "red"
                                : "black",
                          }}
                        >
                          {data?.expiry_date ||
                            data?.plate_details?.expiry_date ||
                            "."}
                        </p>
                      </div>
                    </div>
                  )}
                </div>
                <p>{`${data?.product?.product_type || ""} ${
                  data?.product?.product_type ? "-" : ""
                } ${data?.product?.product_name || ""}`}</p>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

export default Table;
